import React, { useEffect } from "react";
import { Info } from "lucide-react";

function Onderzoek() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="my-36 px-6">
      {/* Hero image (keep as-is) */}
{/*       <section className="items-center">
        <img
          src={"/assets/images/18mag-vangogh-promoimage-superJumbo.jpg"}
          alt="Ik ben Jo! – Van Gogh Museum"
          className="max-w-4xl mx-auto object-cover rounded-3xl my-8 aspect-[8/4]"
        />
      </section> */}

      {/* Article */}
      
      <article className="font-gotham text-black mx-auto max-w-prose my-12">

<p className="flex items-center gap-3 bg-white/60 p-4 px-8 rounded-2xl my-8 text-sm text-gray-900 w-fit">
  <Info className="h-5 w-5 text-gray-600 shrink-0" />
  <span>As of now, this page is only available in Dutch</span>
</p>

        {/* Title + metadata */}
        <header className="mb-10">
          <h1 className="text-3xl md:text-4xl font-semibold leading-tight">
            Rapportage kwalitatief evaluatieonderzoek ‘Ik ben Jo!’
          </h1>

          <p className="mt-6 text-xl">
            Bevindingen uit 20 interviews met deelnemers van het creatieve empowermenttraject ‘Ik ben Jo!’.
          </p>

          <div className="mt-6 text-base space-y-2">
            <p><span className="font-bold">Naam auteur:</span> Romy Raaben</p>
            <p><span className="font-bold">In samenwerking met:</span> Marieke Boon</p>
            <p><span className="font-bold">Onder leiding van:</span> Manon Moussa-Roodenburg</p>
            <p><span className="font-bold">In opdracht van:</span> Van Gogh Museum</p>
            <p><span className="font-bold">Datum:</span> 31 juli 2025</p>
          </div>
        </header>

        {/* Inleiding */}
        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">Inleiding</h2>
          <div className="text-base leading-relaxed space-y-4">
            <p>
              ‘Ik ben Jo!’ is een creatief empowermenttraject dat vrouwen in verschillende Amsterdamse
              stadsdelen samenbrengt rondom het levensverhaal van Jo van Gogh-Bonger. Jo was de vrouw
              van Theo van Gogh en de schoonzus van Vincent, maar vooral: een krachtige vrouw die na de
              dood van haar man en zwager hun nalatenschap beschermde en tot bloei bracht. Ze speelde
              een cruciale rol in de wereldwijde erkenning van Vincent van Gogh en zijn kunstwerken.
              Haar levensverhaal is de inspiratiebron voor dit project, waarin vrouwen reflecteren op hun
              eigen kracht, uitdagingen en veerkracht. Het project heeft als doel hen te equiperen met
              vaardigheden en kennis die hen zelfstandiger en weerbaarder maakt in de Nederlandse
              samenleving.
            </p>

            <p>
              Het project werd uitgevoerd in samenwerking met het Van Gogh Museum en de
              alliantie Samen Sterk met Werk, en bestond uit een serie ontmoetingen, creatieve workshops
              en een bezoek aan het museum. De deelnemers werkten individueel en in groepsverband aan
              een gezamenlijk kunstwerk, geïnspireerd door hun persoonlijke verhaal én dat van Jo. In deze
              bijeenkomsten stond niet alleen het maken van kunst centraal, maar ook ontmoeting,
              uitwisseling en reflectie.
            </p>

            <p>
              Het kwalitatieve onderzoek dat hier wordt gerapporteerd, is uitgevoerd om zicht te
              krijgen op welke betekenis het project heeft gehad voor vrouwen die deelnamen. Wat leerden
              zij over zichzelf? Wat vonden zij waardevol, moeilijk, inspirerend of juist confronterend? En
              in hoeverre sluit het project aan bij de doelen die het zich stelt, zoals het vergroten van
              zelfvertrouwen, het bevorderen van creatieve expressie en het verlagen van de drempel tot
              musea en kunst? De inzichten uit dit onderzoek dragen bij aan het verder verbeteren van
              toekomstige edities van ‘Ik ben Jo!’, en bieden bewijs voor de impact die het project heeft op
              individueel en maatschappelijk niveau.
            </p>

            <p>
              De rapportage richt zich op twee doelen: ten eerste om betrokken partners inzicht te
              geven in de opbrengsten en ervaringen van deelnemers; en ten tweede om aanbevelingen te
              formuleren voor een vervolg van het project.
            </p>

            <p>
              Aan het onderzoek deden twintig vrouwen mee, met diverse achtergronden en
              leeftijden. Sommigen waren al eerder creatief actief of vertrouwd met musea; anderen stonden
              juist ver van kunst en cultuur af. Allen deelden met ons, Marieke en Romy, hun eigen verhaal.
              Deze rapportage is mede aan hen te danken.
            </p>
          </div>
        </section>

        {/* Onderzoeksopzet en methode */}
        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">Onderzoeksopzet en methode</h2>

          <div className="space-y-10 text-base leading-relaxed">
            <section>
              <h3 className="text-xl font-semibold mb-3">Doel van het evaluatieonderzoek</h3>
              <p>
                Het project ‘Ik ben Jo!’ is opgezet met als doel om vrouwen in Amsterdam te inspireren en te
                versterken via kunst en verhalen. Centraal staan thema’s als zelfontplooiing, creativiteit,
                empowerment en verbinding tussen vrouwen uit verschillende stadsdelen en achtergronden.
                Het kwalitatieve onderzoek dat hier wordt gerapporteerd, is uitgevoerd om zicht te krijgen op
                de betekenis die het project Ik ben Jo! heeft gehad voor de vrouwen die deelnamen.
              </p>

              <p className="mt-4">
                Het evaluatieonderzoek naar de ervaringen van de deelnemers heeft twee doelen: 1. Betekenis
                en impact in kaart brengen: inzicht krijgen in hoe vrouwen het project hebben ervaren:
                wat zij leerden over zichzelf, welke onderdelen zij waardevol of juist lastig vonden, en
                welke persoonlijke of sociale opbrengsten zij benoemen. 2. Aansluiting bij
                projectdoelen toetsen: nagaan in welke mate de ervaringen en opbrengsten van de
                deelneemsters overeenkomen met de doelstellingen die in het projectplan zijn
                geformuleerd, zoals empowerment, cultuurparticipatie en sociale verbinding.
              </p>

              <p className="mt-4">
                De inzichten uit dit onderzoek dragen bij aan het verder verbeteren van toekomstige edities
                van Ik ben Jo! én bieden onderbouwing voor de impact die het project heeft op individueel en
                maatschappelijk niveau.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">Onderzoeksvraag</h3>
              <p>
                De centrale vraag die dit onderzoek richting geeft, luidt: Hoe ervaren deelneemsters het
                project “Ik ben Jo!” en welke impact heeft deelname op hun persoonlijke ontwikkeling,
                creatieve expressie en culturele betrokkenheid?
              </p>

              <p className="mt-4">
                Om deze vraag te beantwoorden is een vaste interviewvragenlijst ontwikkeld (zie
                Bijlage 1). De vragenlijst is direct gebaseerd op de onderzoeksvraag en richtte zich op
                verschillende invalshoeken van de ervaring van deelneemsters, zoals hun motivatie om mee te
                doen, hun beleving van de activiteiten, de opbrengsten die zij ervaren, de betekenis van het
                verhaal van Jo en hun wensen voor de toekomst.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">Onderzoeksdesign</h3>
              <p>
                Voor dit onderzoek is gekozen voor een kwalitatieve aanpak. Deze methode sluit goed aan bij
                de aard van de onderzoeksvraag, omdat het gaat om persoonlijke ervaringen, betekenissen en
                verhalen. Kwalitatief onderzoek is gericht op het verdiepen van inzichten in beleving en
                impact.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">Dataverzameling</h3>
              <p>
                Er zijn in totaal 20 semi-gestructureerde interviews individueel afgenomen met deelneemsters
                van Ik ben Jo! in de periode april tot en met juli 2025. De interviews volgden een vaste
                vragenlijst (zie Bijlage 1) die fungeerde als leidraad. Dit zorgde voor een zekere mate van
                uniformiteit tussen de gesprekken, terwijl er tegelijk ruimte bleef voor doorvragen en het
                inbrengen van persoonlijke verhalen.
              </p>

              <p className="mt-4">De vragenlijst omvatte thema’s als:</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Motivatie om deel te nemen,</li>
                <li>Opbrengsten op persoonlijk en sociaal vlak,</li>
                <li>Ervaringen met de verschillende onderdelen van het project,</li>
                <li>Eerdere ervaring met musea en kunst,</li>
                <li>Verbinding en groepsdynamiek,</li>
                <li>Identificatie met het verhaal van Jo,</li>
                <li>Wensen voor de toekomst en tips voor verbetering.</li>
              </ul>

              <p className="mt-4">
                De gesprekken duurden gemiddeld 45 tot 60 minuten en vonden plaats bij deelneemsters
                thuis, in het Van Gogh Museum of in de openbare ruimte zoals een café. De locaties zijn
                bepaald door de vrouwen zelf. Enkele interviews zijn telefonisch of via Teams afgenomen.
              </p>

              <p className="mt-4">
                Ze zijn door onszelf, Marieke en Romy, uitgeschreven en geanonimiseerd. Waar mogelijk
                zijn letterlijke citaten bewaard, omdat deze een sterk beeld geven van de ervaringen en
                emoties van de deelneemsters tijdens het project.
              </p>

              <p className="mt-4">
                Niet alle vrouwen hebben op alle interviewvragen antwoord gegeven. Soms was de tijd
                of energie van de deelnemers beperkt, soms was taal een beperkende factor. Naast de
                interviews zijn er ook analyses gedaan en meegenomen uit observaties en korte gesprekken
                tijdens bijeenkomsten.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">Deelnemers</h3>
              <p>
                De onderzoeksgroep van twintig deelneemsters bestond uit vrouwen uit vijf verschillende
                stadsdelen van Amsterdam (Nieuw-West, West, Zuidoost, Oost en Noord). De leeftijden
                varieerden van circa 30 tot ruim 60 jaar. De groep was cultureel divers en bestond zowel uit
                vrouwen die al ervaring hadden met kunst en creativiteit, als uit vrouwen die nog nooit eerder
                een museum hadden bezocht of zich met kunst bezig hadden gehouden. Deze variatie maakt
                het mogelijk om verschillende ervaringen en perspectieven in beeld te brengen.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">Analyse</h3>
              <p>
                De analyse van de interviews is uitgevoerd volgens de methode van thematische analyse. Dit
                houdt in dat de uitgeschreven interviews in meerdere stappen zijn gecodeerd: - Open coderen:
                markeren van betekenisvolle uitspraken en fragmenten. - Axiaal coderen: groeperen van codes
                in bredere thema’s, zoals motivatie, creativiteit, zelfvertrouwen, sociale opbrengst,
                identificatie met Jo en verbeterpunten. - Selectief coderen: selecteren van de meest relevante
                thema’s en het zoeken naar verbanden tussen de ervaringen van verschillende vrouwen.
              </p>

              <p className="mt-4">
                Deze aanpak maakt het mogelijk zowel overeenkomsten (bijvoorbeeld veel vrouwen
                ontdekten nieuwe creatieve talenten) als verschillen (bijvoorbeeld sommigen voelden zich
                sterk verbonden met Jo’s verhaal, anderen juist niet) te belichten.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">Ethiek</h3>
              <p>
                Bij het uitvoeren van dit onderzoek is veel aandacht besteed aan ethische zorgvuldigheid. Alle
                vrouwen namen op vrijwillige basis deel en konden op ieder moment besluiten om te stoppen
                met het gesprek. Voorafgaand aan de interviews zijn de deelneemsters geïnformeerd over het
                doel van het onderzoek en over de manier waarop hun antwoorden gebruikt zouden worden.
                Hiermee konden zij een weloverwogen keuze maken om wel of niet mee te doen. Om de
                privacy van de deelneemsters te beschermen zijn alle gegevens geanonimiseerd. Na het
                afronden van het onderzoek worden alle transcripten en eventuele opnamen verwijderd. In de
                rapportage wordt zonder namen of pseudoniemen gewerkt. Omdat tijdens de gesprekken soms
                persoonlijke of emotioneel beladen onderwerpen naar voren kwamen, is er steeds zorgvuldig
                en met respect geluisterd naar wat de vrouwen wel of niet wilden delen.
              </p>

              <p className="mt-4">
                Daarnaast is het gebruik van citaten afgestemd met de geïnterviewden. Letterlijke
                uitspraken zijn alleen opgenomen wanneer hiervoor toestemming is gegeven, en waar nodig
                zijn citaten bewerkt om herkenbaarheid te voorkomen.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">Beperkingen</h3>
              <p>
                De resultaten van dit onderzoek zijn gebaseerd op een relatief kleine groep (20
                deelneemsters). Hoewel divers samengesteld, is dit aantal slechts 1/5e deel van alle
                deelneemsters.
              </p>

              <p className="mt-4">
                De uitkomsten geven voornamelijk een kwalitatief beeld van ervaringen en
                opbrengsten, maar zijn niet te kwantificeren of te generaliseren. Ter aanvulling hierop is er
                een enquête gemaakt en verstuurd naar alle deelneemsters van het project. De uitkomsten
                hiervan zijn in een aparte rapportage te vinden.
              </p>

              <p className="mt-4">
                Ook kunnen er tijdens de interviews beperkingen zijn geweest. Zoals de aanwezigheid
                van de interviewer kan van invloed zijn geweest op de manier waarop vrouwen hun
                ervaringen verwoordden en de keuzes die ze maakten om bepaalde ervaringen wel of niet te
                delen.
              </p>

              <p className="mt-4">
                Ondanks deze beperkingen biedt het onderzoek gedetailleerde inzichten die waardevol
                kunnen zijn voor zowel de verdere ontwikkeling van Ik ben Jo! als voor de verantwoording
                van de behaalde resultaten.
              </p>
            </section>
          </div>
        </section>

        {/* Samenvatting van resultaten */}
        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">Samenvatting van resultaten</h2>

          <div className="text-base leading-relaxed space-y-8">
            <section>
              <h3 className="text-xl font-semibold mb-3">1. Motivatie om deel te nemen</h3>
              <p>
                De deelneemsters kwamen op uiteenlopende manieren in aanraking met het project, meestal
                via buurthuizen, coördinatoren of via bekenden in hun sociale netwerk. Hun motivatie was
                vaak een combinatie van nieuwsgierigheid, de wens om creatief bezig te zijn en de behoefte
                aan contact met andere vrouwen. Voor sommigen stond kunst en in het bijzonder het Van
                Gogh Museum centraal, anderen zochten juist zingeving, inspiratie of herstel na een
                moeilijke periode. Ook gaven sommigen aan vooral mee te doen omdat zij door een
                vertrouwde begeleider persoonlijk werd gevraagd.
              </p>
              <p className="mt-4 font-semibold">Quotes</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>“Ik wilde graag iets nieuws proberen, ik was nieuwsgierig en ik hou van out-of-the box.”</li>
                <li>“[naam coördinator buurthuis] vertelde me erover en toen dacht ik meteen: dit moet ik doen!”</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">2. Persoonlijke ontwikkeling en zelfreflectie</h3>
              <p>
                Vrijwel alle vrouwen geven aan dat deelname hen heeft aangezet tot nadenken over zichzelf.
                Voor de één betekende dit een (her)ontdekking van creatieve vermogens, voor de ander meer
                inzicht in persoonlijke kwaliteiten of een sterker zelfvertrouwen. Sommige vrouwen
                omschreven het zelfs als een ‘emotionele ervaring’ die onverwacht diepe gevoelens opriep.
                Tegelijkertijd ervoeren enkelen hun eigen kwetsbaarheid juist sterker in de groep. De meeste
                vrouwen benadrukken echter dat het project hen een gevoel van kracht en eigenwaarde gaf.
                Soms is er ook reflectie op verlangens die helderder zijn geworden. Herinneringen in het
                plezier aan tekenen of schrijven als kind. Of het verlangen om jezelf te (mogen) zien als
                dichter of als creatief mens.
              </p>
              <p className="mt-4 font-semibold">Quotes</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>“Het gaat meer over mij nu. Ik wil in de diepte kijken.”</li>
                <li>“Wauw, het zit gewoon in mij!” en “Ik voelde de passie naar boven komen tijdens de workshops.”</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">3. Creatieve expressie als middel tot empowerment</h3>
              <p>
                Creatief bezig zijn wordt door nagenoeg alle deelneemsters als een waardevol en inspirerend
                onderdeel genoemd. Voor sommigen was dit een hernieuwde kennismaking met tekenen of
                schilderen, voor anderen betekende het juist het ontdekken van een onbekend talent. Het
                creatieve proces gaf trots en erkenning, vooral doordat werken werden tentoongesteld of thuis
                een plek kregen. Een aantal vrouwen spreekt van een katalysator: het project gaf hun het
                duwtje dat nodig was om ook buiten de bijeenkomsten creatief bezig te zijn. Opvallend vaak
                kwam in de interviews terug dat de deelnemers het waardeerden om iets nieuws te leren.
              </p>
              <p className="mt-4 font-semibold">Quotes</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>“Het project heeft als steuntje in de rug gewerkt, ik wilde eerder wel schilderen, maar nu doe ik het ook echt.”</li>
                <li>“Ik vond het leuk om nieuwe dingen te leren. Bijvoorbeeld hoe je een schilderij kan opbouwen in kleine stapjes. Dat hebben ze echt laten zien”.</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">4. Toegankelijkheid kunst en museumbezoek</h3>
              <p>
                Meerdere vrouwen gaven aan voorafgaand aan het project niet of nauwelijks musea te
                bezoeken, bijvoorbeeld vanwege onbekendheid of financiële barrières. Ook gaven een aantal
                deelnemers aan zich normaal gesproken niet op hun plek te voelen in een omgeving zoals die
                van een museum. Door de persoonlijke insteek en begeleiding ervoeren ze nu een gevoel van
                inclusie en waardigheid. Het project maakte kunst begrijpelijker en toegankelijker voor hen.
                Sommigen werden geïnspireerd om vaker musea te bezoeken of hun kinderen mee te nemen.
                Voor een enkeling werkte het juist afstandelijk of te theoretisch en werd er aangegeven dat één
                bezoek voldoende was geweest.
              </p>
              <p className="mt-4 font-semibold">Quotes</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>“Ik snapte kunst nooit, maar nu zie ik de lagen en de emoties. Dat wil ik mijn kinderen ook leren.”</li>
                <li>“Het was chic om in het museum te zijn, om uitgenodigd te zijn.”</li>
                <li>“Als je mensen tijd en uitleg geeft, kan kunst door iedereen begrepen worden. Dit project gaf die ruimte.”</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">5. Verbinding en groepsdynamiek</h3>
              <p>
                Veel vrouwen benoemen de uitwisselingen met anderen als waardevol en inspirerend. De
                ruimte om te delen, het samen creëren, koffiedrinken en het samenzijn, en het wederzijds
                respect werkten in de meeste gevallen verbindend. Sommigen gaven aan vriendschappen te
                hebben gesloten of contact te willen blijven houden met elkaar. Tegelijkertijd gaven enkelen
                ook aan weinig aansluiting te hebben ervaren, bijvoorbeeld omdat er al bestaande groepjes
                onderling waren of door culturele verschillen.
              </p>
              <p className="mt-4 font-semibold">Quotes</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>“Samen even koffiedrinken en wat aardigs tegen elkaar zeggen. Dat was misschien wel het allerbelangrijkste.”</li>
                <li>“Het was heel mooi toen we allemaal een schilderij van onszelf maakten. Het was heel zichtbaar: wat wil ik, wat voor karakter ben ik. En dat zag ik ook bij de anderen; iedereen op haar eigen manier, met haar eigen verhaal.”</li>
                <li>“Veel vrouwen kenden elkaar al en waren al betrokken bij deze plek (locatie in het stadsdeel). Ik voelde me soms de enige met een andere achtergrond.”</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">6. De rol van het verhaal van Jo van Gogh-Bonger</h3>
              <p>
                De identificatie met het verhaal van Jo verschilde sterk per deelneemster. Velen herkenden
                zich in haar veerkracht, doorzettingsvermogen of rol als moeder. Voor anderen bood Jo
                vooral een symbool of als haakje om eigen verhalen te delen. Enkelen vonden het verhaal
                minder relevant of hadden liever bredere perspectieven gezien, zoals aandacht voor het
                slavernijverleden. Een paar vrouwen gaven aan dat juist Vincent van Gogh voor hen meer
                impact maakte, bijvoorbeeld vanwege mentale gezondheid. De balans tussen de ruimte voor
                het eigen verhaal en het verhaal van Jo van Gogh-Bonger werd overwegend als goed ervaren.
              </p>
              <p className="mt-4 font-semibold">Quotes</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>“Ben ik Jo? Nee, ik ben mezelf. Ik waardeer Jo's kracht en doorzettingsvermogen. Dat herken ik bij alle vrouwen die meededen, en ook bij mezelf.”</li>
                <li>“Jo was heel dapper. Ze was alleen en deed het toch. Ik ben niet Jo. Ik ben niet zo sterk. Ik heb meer een zachte kracht. Ik zou liever schilderen, niet de handelaar zijn. Niet vanuit een harde kracht. En die had zij wel nodig.”</li>
                <li>“Het verhaal maakt het makkelijker om te delen over je rol als vrouw, als moeder. Jo is het haakje, het voorbeeld.”</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">7. Behoefte aan vervolg en toekomstwensen</h3>
              <p>
                Veel vrouwen uitten de wens om verder te gaan met creatieve activiteiten, liefst in
                groepsverband komt sterk naar voren. Ze benadrukten dat de inspiratie en verbinding die zijn
                ontstaan, vragen om een vervolg: terugkomdagen, een vervolgtraining of praktische
                ondersteuning, zoals materialen. Sommigen noemden expliciet dat zij de opgedane ervaringen
                ook willen doorgeven aan hun kinderen of andere vrouwen. Een aantal keer is de wens
                uitgesproken voor de mogelijkheden om zelf een rol te kunnen spelen in toekomstige edities.
              </p>
              <p className="mt-4 font-semibold">Quotes</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>“Alleen ga ik niet aan de slag. Thuis heb ik het druk, heb ik geen rust. Ik hoop dat het hier kan, dat we met deze groep verder kunnen. Misschien met een paar nieuwe vrouwen erbij.”</li>
                <li>“Ik wil mij verdiepen in de kunst in Nederland. Kijken wat ze ons aanbieden en wat ik er mee kan. Wat ik eruit kan leren en kan doorgeven aan mijn kinderen.”</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">8. Waardering voor opzet en begeleiding</h3>
              <p>
                Uit de interviews spreekt veel waardering voor de begeleiding, de gastvrijheid en de
                praktische organisatie. Deelneemsters waardeerden de inzet van deskundige
                workshopdocenten, de persoonlijke aandacht en het feit dat er aan alles was gedacht, van
                koffie tot OV-kaartjes. Het Van Gogh Museum werd door velen als bijzonder ervaren, juist
                omdat zij zich er welkom en serieus genomen voelden.
              </p>
              <p className="mt-4 font-semibold">Quotes</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>“Het was top geregeld, fijn dat er altijd koffie, thee en water was bijvoorbeeld.”</li>
                <li>“Voor elke workshop was er een andere docent, iemand die echt weet waar het over gaat. Je leert echt iets.”</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">9. Verrassing</h3>
              <p>
                Veel deelneemsters gaven aan dat het project meer of anders bracht dan zij vooraf
                verwachtten. Ze deden mee vanuit één specifieke motivatie, maar werden positief verrast
                door de combinatie van kunst, ontmoeting, persoonlijke reflectie en creatieve expressie.
                Enkelingen gaven aan negatief verrast te zijn doordat het project onverwacht ook veel ging
                over persoonlijke ontwikkeling en minder over het schilderen zelf.
              </p>
              <p className="mt-4 font-semibold">Quote</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>“Ik kwam voor het schilderen, maar kreeg er zoveel meer bij.”</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">10. Aandachts- en verbeterpunten</h3>

              <div className="space-y-8 mt-4">
                <section>
                  <h4 className="text-lg font-semibold mb-2">10.1 Verwachtingen vooraf</h4>
                  <p>
                    Op basis van de informatie die deelneemsters voorafgaand aan deelname hebben ontvangen
                    hadden sommigen andere verwachtingen van het programma. Niet iedereen vond dat fijn.
                    Verwachtingsmanagement vooraf kan verbeterd worden.
                  </p>
                  <p className="mt-4 font-semibold">Quotes</p>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>“Ik dacht dat het programma over kunst ging. Maar het ging ook heel veel over feminisme. Dat vond ik niet leuk, ik herkende me daar niet in.”</li>
                    <li>“Soms was het therapie achtig. Heel veel gericht op de groep. Dat vond ik vooraf niet duidelijk.”</li>
                  </ul>
                </section>

                <section>
                  <h4 className="text-lg font-semibold mb-2">10.2 Inhoud programma</h4>
                  <p>
                    Een aantal vrouwen hebben benoemd dat zij graag meer hadden willen schilderen. Velen
                    gaven aan de tijd van de schilderworkshop te kort gevonden te hebben en gaven aan meerdere
                    schildermomenten te wensen. Ook is een aantal keer de behoefte uitgesproken om kinderen of
                    vriendinnen meer te kunnen betrekken, niet slechts aan het einde van het project maar ook
                    tussendoor. Daarnaast hebben sommige vrouwen aangegeven niet altijd een prettig gevoel te
                    hebben gehad bij de groepsdynamiek. Gevoelens van uitsluiting en moeite met verplichte
                    samenwerking werden genoemd als oorzaken hiervan. Enkelen benoemden nadrukkelijk geen
                    plezier te hebben gehaald uit het maken van een gezamenlijk kunstwerk.
                  </p>
                  <p className="mt-4 font-semibold">Quotes</p>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>“Het werd echt lelijk, de anderen gingen over mijn stukje heen schilderen. Het werd ook niet goed uitgelegd, het was rommelig.”</li>
                  </ul>
                </section>

                <section>
                  <h4 className="text-lg font-semibold mb-2">10.3 Toegankelijkheid programma</h4>
                  <p>
                    Relatief veel deelneemsters ontvingen de informatie over het project via coördinatoren van
                    buurthuizen. Deze manier van werven pakte goed uit voor de deelneemsters, maar riep bij
                    sommige van hen vragen op over de toegankelijkheid van deelname als je als vrouw niet reeds
                    betrokken bent bij een buurthuis.
                  </p>

                  <p className="mt-4">
                    Enkelingen benoemden dat armoede een drempel kan vormen in de deelname, zelfs al
                    zijn de bijeenkomsten gratis. Volgens moet het beter gecommuniceerd worden dat er gratis
                    koffie en thee is en dat het OV in sommige situaties betaald wordt door de organisatie.
                  </p>

                  <p className="mt-4">
                    Uit navraag van Marieke bleek dat in Noord (in Floradorp en Tuindorp) veel interesse
                    was voor het verhaal van Jo, maar uiteindelijk meldde niemand zich aan. In gesprek merkte
                    Marieke op dat de drempel om mee te doen te hoog was, vanwege het gevoel de partner in
                    Noord niet goed te kennen en het gevoel dat het project gericht is op allochtone vrouwen.
                  </p>

                  <p className="mt-4 font-semibold">Quotes</p>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>“Vrouwen maken zich zorgen als het met lunchtijd is. Moet ik daar iets kopen, kan ik zelf iets meenemen? Dat maakt onzeker”.</li>
                  </ul>
                </section>

                <section>
                  <h4 className="text-lg font-semibold mb-2">10.4 Praktische aandachts- en verbeterpunten</h4>
                  <p>
                    In de interviews werden vaak praktische en organisatorische punten genoemd te verbetering.
                    Wat door een aantal als minpunt werd ervaren was dat andere deelneemsters uit de groep soms
                    te laat of helemaal niet kwamen. Ook gaf een enkeling aan het niet handig te vinden dat de
                    dagen waarop de bijeenkomsten plaatsvonden tussendoor veranderd werden.
                  </p>
                  <p className="mt-4 font-semibold">Quotes</p>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>“Vaak kwamen er mensen te laat. Dat stoort mij, maar ik heb er niks van gezegd.”</li>
                    <li>“Mijn tip is om niet tussendoor nog de dagen te veranderen.”</li>
                  </ul>
                </section>
              </div>
            </section>
          </div>
        </section>

        {/* Impact */}
        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">Impact</h2>
          <div className="text-base leading-relaxed space-y-6">
            <p>
              In dit hoofdstuk worden de resultaten van het evaluatieonderzoek besproken in relatie tot de
              doelen uit het projectplan. Op basis van de twintig interviews laten de resultaten zien dat het
              project bijdraagt aan vier kerndoelen: het vergroten van zelfvertrouwen en persoonlijke
              veerkracht, het stimuleren van creatieve expressie, het bevorderen van verbinding en
              ontmoeting, en het verlagen van de drempel tot kunst en musea.
            </p>

            <section>
              <h3 className="text-xl font-semibold mb-3">1. Zelfvertrouwen en persoonlijke veerkracht</h3>
              <p>
                Een belangrijk doel van het project was het versterken van het zelfvertrouwen van de
                deelnemende vrouwen. In de interviews komt dit thema zeer frequent terug. Veel
                deelneemsters benoemden dat ze zich na afloop sterker, bewuster of ‘meer zichzelf’ voelden.
                Voor sommigen was het herontdekken van creativiteit een bron van trots, voor anderen bood
                het delen van verhalen erkenning en bevestiging. Uitspraken als “Het gaat meer over mij nu.
                Ik wil in de diepte kijken.” en “Wauw, het zit gewoon in mij!” en “Ik voelde de passie naar
                boven komen tijdens de workshops” laten zien dat het traject meer was dan een reeks
                workshops: het fungeerde als een proces van persoonlijke groei en empowerment.
              </p>

              <p className="mt-4">
                Tegelijkertijd waren er enkele vrouwen die juist hun kwetsbaarheid sterker voelden
                binnen de groep. Deze geluiden laten zien dat het project veel kan losmaken en dat het
                belangrijk blijft om voldoende ruimte te bieden voor verschillen in tempo en behoefte.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">2. Creatieve expressie stimuleren</h3>
              <p>
                Alle geïnterviewden noemden het creatieve proces waardevol. Voor sommigen was het een
                hernieuwde kennismaking met een oude passie, voor anderen een eerste stap richting
                kunstzinnige expressie. Het leren van technieken, het experimenteren met materialen en het
                zichtbaar maken van eigen werk droeg hieraan bij.
              </p>

              <p className="mt-4">
                Door de kunstwerken van de deelneemsters tentoon te stellen in het Van Gogh
                Museum, werd de trots versterkt. Het creatieve proces werkte daarbij niet alleen als
                ontspanning, maar ook als katalysator voor verandering: deelneemsters gingen zich zien als
                iemand die kan creëren en dat talent mag uitdragen.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">3. Verbinding en ontmoeting</h3>
              <p>
                De waarde van verbinding met andere vrouwen komt sterk naar voren. Het delen van
                persoonlijke verhalen, samen kunst maken en eenvoudige momenten van samenzijn, zoals
                koffiedrinken, werden vaak genoemd als belangrijk. Vrouwen beschreven dat zij steun vonden
                bij elkaar, nieuwe vriendschappen sloten of zelfs spraken van een ‘nieuwe familie’. Een
                deelneemster verwoordde het zo: “Samen even koffiedrinken en wat aardigs tegen elkaar
                zeggen, dat was misschien wel het allerbelangrijkste”.
              </p>

              <p className="mt-4">
                Niet iedereen vond aansluiting: enkelen ervoeren een afstand door bestaande groepjes of
                culturele verschillen. Toch overheerst het beeld dat Ik ben Jo! een gevoel van
                gemeenschappelijkheid creëerde dat voor veel vrouwen waardevol was.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">4. Toegang tot kunst en musea, en zichtbaarheid vergroten</h3>
              <p>
                Voor veel deelneemsters betekende het project een eerste kennismaking met musea of een
                hernieuwd bezoek na lange tijd. Belemmeringen zoals onbekendheid, financiële drempels of
                het gevoel dat musea “niet voor hen” waren, werden doorbroken. Door samen naar het Van
                Gogh Museum te gaan en uitleg en context te krijgen, voelden vrouwen zich welkom en
                serieus genomen.
              </p>

              <p className="mt-4">
                Deze toegankelijkheid zorgde ervoor dat verschillende vrouwen aangaven vaker
                musea te willen bezoeken of hun kinderen mee te nemen. Het project vergrootte daarmee niet
                alleen hun eigen culturele participatie, maar ook de kans dat zij kunst en cultuur doorgeven
                aan de volgende generatie.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">Samenvattend</h3>
              <p>
                De impact van het project Ik ben Jo! is zichtbaar op individueel niveau, in het
                zelfvertrouwen, de creativiteit en persoonlijke ontwikkeling. Maar ook op maatschappelijk
                niveau is de impact zichtbaar in het succesvol verlagen van bepaalde drempels tot
                cultuurdeelname en in de ontstane verbinding tussen de deelneemsters. Niet alle ervaringen
                waren eenduidig positief, maar de rode draad lijkt duidelijk: het project draagt in belangrijke
                mate bij aan de doelen waarvoor het is opgezet en heeft voor veel van de deelnemende
                vrouwen een blijvende betekenis.
              </p>
            </section>
          </div>
        </section>

        {/* Conclusies en aanbevelingen */}
        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">Conclusies en aanbevelingen</h2>

          <div className="text-base leading-relaxed space-y-8">
            <section>
              <h3 className="text-xl font-semibold mb-3">Conclusies</h3>
              <p>Het onderzoek laat zien dat Ik ben Jo! voor veel vrouwen een betekenisvolle ervaring is geweest. De belangrijkste opbrengsten zijn:</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Zelfvertrouwen en persoonlijke groei: veel vrouwen voelden zich sterker, serieuzer genomen en zagen nieuwe mogelijkheden in zichzelf.</li>
                <li>Creatieve expressie: deelname bood vrouwen de kans talenten te (her)ontdekken en trots te ervaren door het maken en tonen van hun werk.</li>
                <li>Verbinding: de ontmoeting en het samenzijn met andere vrouwen gaven steun, inspiratie en soms blijvende vriendschappen.</li>
                <li>Toegang tot kunst en musea: vrouwen voelden zich welkom in het Van Gogh Museum en gaven aan vaker musea te willen bezoeken, ook met hun kinderen.</li>
              </ul>

              <p className="mt-4">
                Tegelijkertijd kwamen ook verbeterpunten naar voren. Niet iedereen voelde zich volledig
                thuis in de groep, verwachtingen over de inhoud liepen soms uiteen, en waren er praktische
                verbeterpunten. Ook werd genoemd dat de werving breder en toegankelijker kan, zodat ook
                vrouwen die nog geen aansluiting hebben bij een buurthuis of netwerk makkelijker kunnen
                instappen.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold mb-3">Aanbevelingen</h3>
              <p>
                Ter verbetering van toekomstige edities van het project zouden de volgende aanbevelingen in
                overweging genomen kunnen worden. Deze zijn gebaseerd op de ervaringen van de twintig
                deelneemsters aan dit evaluatieonderzoek.
              </p>

              <div className="space-y-6 mt-4">
                <section>
                  <h4 className="text-lg font-semibold mb-2">1. Zorg voor duidelijk verwachtingsmanagement vooraf</h4>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Leg in de uitnodiging en communicatie beter uit wat deelnemers kunnen verwachten: dat Ik ben Jo! niet alleen een kunstproject is, maar ook persoonlijke reflectie en groepsuitwisseling bevat.</li>
                    <li>Overweeg een korte introductiebijeenkomst of flyer waarin de balans tussen kunst, persoonlijke verhalen en groepsdynamiek helder wordt uitgelegd.</li>
                  </ul>
                </section>

                <section>
                  <h4 className="text-lg font-semibold mb-2">2. Versterk en verdiep het creatieve aanbod</h4>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Veel vrouwen willen meer tijd besteden aan schilderen, tekenen of schrijven. Overweeg langere sessies, meer bijeenkomsten of verdiepende workshops.</li>
                    <li>Zorg voor voldoende materialen en laat vrouwen ook thuis of in het buurthuis verder oefenen, bijvoorbeeld door kleine opdrachten of een creatief pakket mee te geven. 3. Bied een vervolg</li>
                  </ul>
                </section>

                <section>
                  <h4 className="text-lg font-semibold mb-2">3. Bied een vervolg</h4>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Creëer mogelijkheden voor een vervolgtraject: terugkomdagen, een vervolgtraining of een doorlopend ateliermoment in samenwerking met buurthuizen.</li>
                    <li>Stimuleer dat vrouwen hun nieuwe vaardigheden en inspiratie doorgeven, bijvoorbeeld door ze te ondersteunen bij het opzetten van kleine groepjes of door hen te vragen een rol te spelen in toekomstige edities van het project.</li>
                  </ul>
                </section>

                <section>
                  <h4 className="text-lg font-semibold mb-2">4. Vergroot toegankelijkheid</h4>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Benadruk in de communicatie dat deelname gratis is, inclusief eventueel vervoer (geregeld door de alliantie Samen Sterk met Werk), koffie en thee, zodat financiële zorgen geen drempel vormen.</li>
                  </ul>
                </section>

                <section>
                  <h4 className="text-lg font-semibold mb-2">5. Begeleid groepsdynamiek</h4>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Besteed aandacht aan het doorbreken van bestaande subgroepen.</li>
                    <li>Bied voldoende begeleiding om ervoor te zorgen dat iedereen zich veilig en gehoord voelt.</li>
                    <li>Experimenteer met werkvormen waarin samenwerken niet verplicht is, zodat ook vrouwen die liever individueel werken zich prettig voelen.</li>
                  </ul>
                </section>

                <section>
                  <h4 className="text-lg font-semibold mb-2">6. Verbind het project sterker met actuele thema’s</h4>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Enkele vrouwen misten aandacht voor thema’s zoals het slavernijverleden of bredere culturele verhalen. Overweeg om in toekomstige edities naast Jo’s verhaal ook andere perspectieven te belichten.</li>
                  </ul>
                </section>
              </div>
            </section>
          </div>
        </section>

        {/* Bijlagen */}
        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">Bijlagen</h2>

          <section className="text-base leading-relaxed">
            <h3 className="text-xl font-semibold mb-3">Bijlage 1: vragenlijst interview</h3>

            <ol className="list-decimal pl-6 space-y-2">
              <li>Naam (voor en achternaam), stadsdeel, leeftijd</li>
              <li>Was je voordat je meedeed wel eens in het van Gogh Museum geweest? In andere musea? En hoe is dat nu, wil je dit in de (nabije) toekomst doen?</li>
              <li>Hoe wist je van het programma ‘Ik ben Jo’?</li>
              <li>Waarom wilde je meedoen?</li>
              <li>Hoe was het voor jou om deel te nemen aan ik ben Jo?</li>
              <li>
                Welk onderdeel vond je het meest waardevol?
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>creatief, dingen maken</li>
                  <li>uitwisseling andere vrouwen</li>
                  <li>verhaal van Jo,</li>
                  <li>naar nieuwe plekken toe</li>
                  <li>anders namelijk</li>
                </ul>
              </li>
              <li>
                Wat heeft het opgeleverd voor jou?
                <div className="mt-2 space-y-1">
                  <p>iets geleerd,</p>
                  <p>mensen leren kennen,</p>
                  <p>jezelf beter leren kennen,</p>
                  <p>nieuwe ideeën/richting,</p>
                  <p>zelfvertrouwen</p>
                  <p>anders nl</p>
                  <p>Niets</p>
                </div>
              </li>
              <li>Wat vond je niet prettig/niet nodig, lastig of stom?</li>
              <li>Over de verhaallijn Ik ben Jo: wat herken jij in Jo, waarom ben jij Jo?</li>
              <li>Ben je, door de kennismaking met Jo, anders naar jezelf gaan kijken?</li>
              <li>Wat vind je van de balans in het project tussen de verhaallijn van Jo en jouw eigen persoonlijke verhaal?</li>
              <li>Tijdens Ik ben Jo ben je ook zelf creatief aan de slag gegaan. Deed je dat hiervoor ook zelf? (zo ja wat)</li>
              <li>Heeft deelname aan Jo je geïnspireerd vaker creatief aan de slag te gaan? (zo ja hoe of wat)</li>
              <li>Heb je hierin een wens? (clubje, creatieve opdrachten, contact blijven houden)?</li>
              <li>Hoe was de uitwisseling met andere vrouwen voor jou?</li>
              <li>Blijf je een deel van de groep zien?</li>
              <li>Is er iets dat je meeneemt naar je toekomst (voornemen, idee, plan, nieuwe stap)?</li>
              <li>Heb je hier nog iets voor nodig om dit te kunnen doen?</li>
              <li>Wat neem je mee naar anderen om je heen? (Om hen te helpen/inspireren)</li>
              <li>Tips voor vervolg</li>
            </ol>
          </section>
        </section>
      </article>
    </div>
  );
}

export default Onderzoek;
